import React, {
    useContext
} from "react";

import AuthenticatedUserContext from "../context/AuthenticatedUserContext";
import Helmet from "../components/Helmet";
import Logo from "../components/Logo";
import ProfileBanner from "../components/profile/ProfileBanner";
import UserVehicles from "../components/profile/vehicles/UserVehicles";
import ProfileAddressCard from "../components/profile/ProfileAddressCard";
import { Alert } from "react-bootstrap";

function Account() {
    const authenticatedUser = useContext(AuthenticatedUserContext);
    return (
        <React.Fragment>
            <Helmet title="Account"/>
            <div className="background-login">
                <div className="d-flex flex-column align-items-center w-100">
                    <Logo/>
                    <div
                        className="mt-3"
                        style={{ width: "100%", maxWidth: "1000px" }}
                    >
                        <ProfileBanner user={ authenticatedUser.user }/>
                        <Alert variant="warning">
                            <div className="d-flex flex-row align-items-center justify-content-between">
                                <span className="mr-2">
                                    Geef feedback over jouw ervaring met DRVR! Wij zijn continu bezig met het verbeteren van DRVR en horen daarom jouw mening graag.
                                </span>
                                <a href="https://5fv5i6im32t.typeform.com/to/JspqOlCH" className="btn btn-primary d-flex flex-row align-items-center mobile-no-shrink" target="_blank" rel="noopener noreferrer">
                                    <i className="fa-solid fa-arrow-up-right-from-square mr-2"/>
                                    Feedback geven
                                </a>
                            </div>
                        </Alert>
                        <div className="card mb-3">
                            <div className="card-body">
                                <h5 className="card-title">Gegevens</h5>
                                <p className="card-text">
                                    <strong>Naam:</strong> {authenticatedUser.user.name}<br/>
                                    <strong>E-mail:</strong> {authenticatedUser.user.email}
                                </p>
                            </div>
                        </div>
                        <ProfileAddressCard/>
                        <UserVehicles
                            user={ authenticatedUser.user }
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default React.memo(Account);
